import { t } from "i18next";
import React from "react";
import Input, { Value as E164Number } from "react-phone-number-input/input";

import { formatPhoneNumber } from "@/utils/format-phone-number";

type PhoneNumberInputProps = {
    value: string;
    onChange: (value: E164Number) => void;
    onEnterPress: () => void;
};

export const PhoneNumberInput = ({ value, onChange, onEnterPress }: PhoneNumberInputProps) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            onEnterPress();
        }
    };

    const handlePhoneNumberChange = (value: E164Number) => {
        if (!value) {
            onChange("" as E164Number);
        } else {
            const parsedValue = formatPhoneNumber(value, "E.164", true);
            onChange(parsedValue as E164Number);
        }
    };

    return (
        <Input
            value={value as E164Number}
            onChange={handlePhoneNumberChange}
            onKeyDown={handleKeyDown}
            placeholder={t("enter_phone_number")}
            className="w-full h-12 text-md font-semibold rounded-lg px-4 bg-muted border-1 border-transparent focus:border-primary focus:border-1"
        />
    );
};
